<template>
  

    <div class="ItemTreeSEDetailsArray" >
        
      <li>
        <span v-if="Array.isArray(model)">
            <span v-if="isSearch == false"   > 
              <span class="empty-item" v-if="model.length == 0">[ ]</span>
            </span>
            <span v-for="(item,index) in model" :key="index">
              
              <span v-if="isSearch == false">  
                <span class="numbers">{{ index }}:</span>
              </span>

                    
              <ItemTreeSEDetailsObject 
                class="item" 
                v-if="!Array.isArray(item) && item != null" 
                :model="item"
                :specialParam="specialParam"
                :searchString="searchString"
                
                :parentName="parentName + String(index) + '/'"
              ></ItemTreeSEDetailsObject>
              <ItemTreeSEDetailsArray
                class="item" 
                v-if="Array.isArray(item) && item != null"  
                :model="item"
                :specialParam="specialParam"
                :searchString="searchString"
                :parentName="parentName + String(index) + '/'"
              ></ItemTreeSEDetailsArray>
                

                
            </span>
        </span>
        
        

      </li>
    </div>
    
  
</template>

<script>

// import ItemTreeSEDetailsObject from "@/components/shared/ItemTreeSEDetailsObject"
// import ItemTreeSEDetailsArray from "@/components/shared/ItemTreeSEDetailsArray"

export default {
    name: 'ItemTreeSEDetailsArray',
    components: {
        ItemTreeSEDetailsObject: () => import("@/components/shared/ItemTreeSEDetailsObject"),
        ItemTreeSEDetailsArray: () => import("@/components/shared/ItemTreeSEDetailsArray"),
    },
    props: {
      model: Array,
      specialParam: Object,
      searchString: String,
      parentName: String
    },
    data: function () {
        return {
            openArray: [],
            visibleElement: false 

        };
    },
    computed: {
           
      uid(){

          return this._uid
      },
      isSearch() {
        return this.searchString.length > 2;
      },
        
      searchStringExist() {
          let name = this.model.name.toLowerCase();
          
          let index = name.indexOf(this.searchString.toLowerCase());
          
          if (index > -1) {
              return true;

          } else {
              return false;

          }
      
      }


    },
    created () {
        this.init();
    },
    watch: {

    },
  
    methods: {
                
      init() {
        this.openArray = [];
        let index = 0;
        for (let item in this.model) {
          
          let obj = {
            item: item,
            open: false,
            index: index
          }
          index++;
          this.openArray.push(obj);
        }
        
        
      },
      setVisible(value) {
        
        this.visibleElement = value;
      },
      setParentVisible() {
        try {
          this.$parent.setVisible(this.parentName);
        } catch (ex) {
          //console.log(ex)
        }
      },
      checkSimilar(model, item) {

        if (this.isSearch == false) {

          return true;
        }

        let str = this.searchString.toLowerCase();
        

        if (typeof model[item] == "string") {
          let pos1 = item.toLowerCase().indexOf(str);
          
          if (pos1 > -1) {
            
            return true;
          }

          let pos2 = model[item].toLowerCase().indexOf(str);

          if (pos2 > -1) {
            
            return true;
          }
        }
        

        return false;
      },
      toggle: function (index) {
                
                  
        this.openArray[index].open = !this.openArray[index].open;

      },
    
    
  }
}
</script>


<style lang="scss">

  .ItemTreeSEDetailsArray{
    li {
      width: fit-content;
    }
    .expandimage {
      width: 16px;
      height: 16px;
      margin-left: 5px;
    }
    .expand__container{
      width:20px;
      height: 15px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      flex-direction: column;
    }
    .item {
      cursor: pointer;
        margin-bottom: 20px;
    }
    .library_ul {
      padding-left: 18px;
      line-height: 1.1em;
      list-style-type: none;

    }
    .numbers{
        color:#999;
    }
    .item__name{
      cursor: pointer;
      font-size: 0.75rem;
    }
    .empty-item{
        margin-left: 30px;
    }
    

    .treeline{
      display: inline-flex;

    }

    a{
      padding-right: 10px;
      padding-left: 10px;
    }

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/ItemTreeSEDetailsArray.vue